import { getBalanceReportLocal } from "../db/report/baoCaoTongHopNgay";
import { FetchContactReport3MienLocal, FetchContactReportAllInOneLocal, FetchDetailsReportByContactIDLocal, FetchDetailsReportByMessageIDLocal } from "../db/report/localBackend";
import { isLocalMode } from "../utils/common";
import ApiHelper from "./ApiHelper";

const ReportApi = {
    FetchBasicTotalReport: async (payload) => {
        if (isLocalMode()) {
            return FetchContactReportAllInOneLocal(payload)
        }
        else {
            const { contactId, messageId, ngay, mienDaiCuocId } = payload;
            const url = encodeURI(`report/getTotalReportByContactForceReload?contactId=${contactId}&messageId=${messageId}`
                + `&ngay=${ngay}&mienDaiCuocId=${mienDaiCuocId}`)
            const result = await ApiHelper.get(url)
            return result.data
        }
    },
    FetchBasicMessageListReport: async (payload) => {
        const { contactId, ngay, mienDaiCuocId } = payload;
        const url = encodeURI(`report/getTotalReportMessageLists?contactId=${contactId}&ngay=${ngay}` +
            `&mienDaiCuocId=${mienDaiCuocId}`)
        const result = await ApiHelper.get(url)
        return result.data
    },
    FetchDetailsReportByMessageID: async (payload) => {
        if (isLocalMode()) {
            return FetchDetailsReportByMessageIDLocal(payload)
        }
        else {
            const { messageId, mienDaiCuocId } = payload;
            const url = encodeURI(`report/getDetailsReportByMessageID?messageId=${messageId}&mienDaiCuocId=${mienDaiCuocId}`)
            const result = await ApiHelper.get(url)
            return result.data
        }
    },
    FetchDetailsReportByContactID: async (payload) => {

        if (isLocalMode()) {
            return FetchDetailsReportByContactIDLocal(payload)
        }
        else {
            const { contactId, mienDaiCuocId, ngay } = payload;
            const url = encodeURI(`report/getDetailsReportByContactID?contactId=${contactId}&mienDaiCuocId=${mienDaiCuocId}` +
                `&ngay=${ngay}`)
            const result = await ApiHelper.get(url)
            return result.data
        }
    },
    FetchContactReportAllInOne: async (payload) => {
        if (isLocalMode()) {
            return FetchContactReportAllInOneLocal(payload)
        }
        else {
            const { messageId, mienDaiCuocId, ngay, contactId } = payload;
            const url = encodeURI(`report/getContactReportAllInOne?messageId=${messageId}&mienDaiCuocId=${mienDaiCuocId}` +
                `&ngay=${ngay}&contactId=${contactId}`)
            const result = await ApiHelper.get(url)
            return result.data
        }
    },
    FetchContactReport3Mien: async (payload) => {
        if (isLocalMode()) {
            return FetchContactReport3MienLocal(payload)
        } else {
            const { ngay, contactId } = payload;
            const url = encodeURI(`report/getContactReport3Mien` +
                `?ngay=${ngay}&contactId=${contactId}`)
            const result = await ApiHelper.get(url)
            return result.data
        }
    },
    postBuildKetQua: async (payload) => {
        //payload ={ngay:'2023-08-08'}
        const url = encodeURI(`ketqua/postBuildKetQua`)
        const result = await ApiHelper.post(url, payload)
        return result.data
    },
    postTinhThuong: async (payload) => {
        //payload ={ngay:'2023-08-08'}
        const url = encodeURI(`ketqua/postTinhThuong`)
        const result = await ApiHelper.post(url, payload)
        return result.data
    },
    getBalanceReport: async (payload) => {
        if (isLocalMode()) {
            return getBalanceReportLocal(payload)
        }
        const { ngay } = payload;
        const url = encodeURI(`report/getBalanceReport` +
            `?ngay=${ngay}`)
        const result = await ApiHelper.get(url)
        return result.data
    },
    getBalanceReportByDateRange: async (payload) => {
        if (isLocalMode()) {
            return getBalanceReportLocal(payload)
        }
        const { ngay } = payload;
        const url = encodeURI(`report/getBalanceReport` +
            `?ngay=${ngay}`)
        const result = await ApiHelper.get(url)
        return result.data
    },
    getKetQua: async (payload) => {
        const { ngay } = payload;
        const url = encodeURI(`report/getKetQua` +
            `?ngay=${ngay}`)
        const result = await ApiHelper.get(url)
        return result.data
    },
    getReportWebLink: async (payload) => {
        const { contactId } = payload;
        const url = encodeURI(`/report/getReportLinkForGuest?contactId=${contactId}`)
        const result = await ApiHelper.get(url)
        return result.data
    },
    saveCongNoNgay: async (payload) => {
        const { ngay } = payload
        const url = encodeURI(`report/luuCongNoNgay?ngay=${ngay}`)
        const result = await ApiHelper.post(url, payload)
        return result.data
    },
    getBaoCaoDoanhThu: async (payload) => {
        
        const { tuNgay,denNgay } = payload;
        const url = encodeURI(`report/getBaoCaoDoanhThu` +
            `?tuNgay=${tuNgay}&denNgay=${denNgay}`)
        const result = await ApiHelper.get(url)
        return result.data
    },

}
export default ReportApi